import { createContext, useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import notificationSound from "./Assets/Notification Sound.mpeg";

const GlobalContext = createContext();

export function GlobalProvider({ children }) {
  const [baseurl] = useState("https://api2.packky.com");
  const audioRef = useRef(new Audio(notificationSound));

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = 0.6;
    }
  }, []);

  const [accessToken, setAccessToken] = useState(() => {
    const admin = sessionStorage.getItem("admin");
    return admin ? JSON.parse(admin).accessToken : null;
  });

  const [AdminId, setAdminId] = useState(() => {
    const admin = sessionStorage.getItem("admin");
    return admin ? JSON.parse(admin).userId : null;
  });

  useEffect(() => {
    // console.log(AdminId);
  }, [AdminId]);

  const [showOld, setShowOld] = useState(() => {
    const savedView = localStorage.getItem("viewMode");
    return savedView === "task";
  });

  useEffect(() => {
    localStorage.setItem("viewMode", showOld ? "task" : "map");
  }, [showOld]);

  const [isMuted, setIsMuted] = useState(() => {
    const savedMute = localStorage.getItem("notificationMuted");
    return savedMute === "true";
  });

  const toggleMute = () => {
    setIsMuted((prev) => {
      localStorage.setItem("notificationMuted", !prev);
      return !prev;
    });
  };

  const [ApiCall, setApiCall] = useState(false);
  const [IsUnauthorised, setIsUnauthorised] = useState(false);
  const [admin, setAdmin] = useState(() => {
    const savedAdmin = sessionStorage.getItem("admin");
    return savedAdmin ? JSON.parse(savedAdmin) : null;
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (IsUnauthorised && admin) {
      console.log("its working");
      sessionStorage.removeItem("admin");
      setAdmin(null);
      setAccessToken(null);
      setAdminId(null);
      localStorage.clear();
      setIsUnauthorised(false);

      if (window.location.pathname !== "/login") {
        navigate("/login", { replace: true });
      }
    }
  }, [IsUnauthorised, navigate, admin]);

  useEffect(() => {
    const handleStorageChange = () => {
      const savedAdmin = sessionStorage.getItem("admin");
      if (savedAdmin) {
        const adminData = JSON.parse(savedAdmin);
        setAdmin(adminData);
        setAccessToken(adminData.accessToken);
        setAdminId(adminData.userId);
      } else {
        setAdmin(null);
        setAccessToken(null);
        setAdminId(null);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const username = "packky@gmail.com";
  const password = "Z90LTO34RTNQGT49LCIYRVTXJERZTKX8";
  const token = btoa(`${username}:${password}`);

  const [team, setTeam] = useState("All Team");
  const [searchQueryGlobal, setSearchQueryGlobal] = useState("");

  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState("All Team");

  const [Loading, setLoading] = useState(false);
    const [drivers, setDrivers] = useState([]);

  const [socketData, setSocketData] = useState(null);
  const socketRef = useRef(null);
  const reconnectTimeout = useRef(null);

  // 🔄 Auto-Reconnecting WebSocket
  useEffect(() => {
    if (!admin?.userId) return;

    let reconnectAttempts = 0;
    const maxReconnectAttempts = 5;

    const connectWebSocket = () => {
      const ws = new WebSocket(
        `wss://api2.packky.com/ws?userId=${admin.userId}&roomId=task_room_v1`
      );
      socketRef.current = ws;

      ws.onopen = () => {
        console.log(`${admin.userId} ✅ WebSocket connected`);
        reconnectAttempts = 0;
      };

      ws.onmessage = (event) => {
        try {
          const message = JSON.parse(event.data);
          console.log("📩 Socket Message:", message);
          setSocketData(message);
          setApiCall((prev) => !prev);

          // Play notification sound only if not muted
          if (!isMuted && audioRef.current) {
            audioRef.current.currentTime = 0;
            audioRef.current.play().catch((err) => {
              console.warn(
                "Notification sound blocked until user interacts",
                err
              );
            });
          }
        } catch (e) {
          console.error("❌ Failed to parse socket message", e);
        }
      };

      ws.onerror = (err) => {
        console.error("❌ WebSocket error:", err);
        ws.close(); // Force close to trigger reconnect
      };

      ws.onclose = () => {
        console.warn("⚠️ WebSocket disconnected");

        if (reconnectAttempts < maxReconnectAttempts) {
          const delay = Math.min(1000 * 2 ** reconnectAttempts, 10000); // Exponential backoff
          console.log(`🔁 Reconnecting in ${delay / 1000}s...`);
          reconnectTimeout.current = setTimeout(connectWebSocket, delay);
          reconnectAttempts++;
        } else {
          console.error("🚫 Max reconnect attempts reached.");
        }
      };
    };

    connectWebSocket();

    return () => {
      if (socketRef.current) socketRef.current.close();
      clearTimeout(reconnectTimeout.current);
    };
  }, [admin?.userId, isMuted]);

  // driver call
   const FetchDriverCall = async (silent = false) => {
    if (!silent) setLoading(true);
    try {
      const UserDetail = { userid: "", adminId: AdminId };
      const response = await axios.post(
        `${baseurl}/api/Driver/v1.0/getDriverList`,
        UserDetail,
        { headers: { Authorization: `Basic ${token}` } }
      );
      if (response.data.responseCode === "00") {
        setDrivers(response.data.data);
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error fetching Driver");
    } finally {
      if (!silent) setLoading(false);
    }
  };

  useEffect(() => {
    FetchDriverCall();
  }, []);

  // 🚀 Fetch Teams
  const FetchTeamCall = async () => {
    try {
      const UserDetail = { userid: "9", adminId: AdminId };
      const response = await axios.post(
        `${baseurl}/api/Driver/v1.0/getDriverTeamList`,
        UserDetail,
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (response.data.responseCode === "00") {
        // toast.success(response.data.responseMessage);
        // console.log("✅ Login success:", response.data.responseMessage);
        setTeams(response.data.data);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error fetching Driver Teams");
    }
  };

  useEffect(() => {
    if (admin) {
      FetchTeamCall();
    }
  }, [admin]);

  return (
    <GlobalContext.Provider
      value={{
        baseurl,
        token,
        team,
        setTeam,
        searchQueryGlobal,
        setSearchQueryGlobal,
        teams,
        selectedTeam,
        setSelectedTeam,
        FetchTeamCall,
        FetchDriverCall,
        accessToken,
        setAccessToken,
        ApiCall,
        setApiCall,
        setIsUnauthorised,
        IsUnauthorised,
        socketData,
        AdminId,
        isMuted,
        toggleMute,
        showOld,
        setShowOld,
        admin,
        setAdmin,
        drivers,         
        setDrivers,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
}

export function useGlobalContext() {
  return useContext(GlobalContext);
}